<template>
  <div class="main">
    <h2>{{ $t('msg.platform.title') }}</h2>
    <p class="my-4">{{ $t('msg.platform.subtitle') }}</p>
    <div class="card">
      <div class="card-header py-3">
        <div class="text-right" v-if="$auth.granted(acl.shops.create)">
          <router-link :to="{ path: '/shops/available', query: { account: account } }">
            <a-button
              class="d-md-none"
              icon="plus"
              type="primary"
              shape="circle" />
            <a-button
              class="d-none d-md-inline"
              icon="plus-circle"
              type="primary"
              size="large">
              {{ $t('msg.platform.new.title') }}
            </a-button>
          </router-link>
        </div>
      </div>
      <div class="card-body p-2">
        <a-list
          :data-source="results"
          :pagination="false">
          <a-list-item
            slot="renderItem"
            slot-scope="item"
            class="p-4">
            <a-list-item-meta>
              <h5 slot="title">
                {{ item.name }}
              </h5>
              <a
                slot="description"
                class="text-secondary d-none d-lg-block"
                :href="item.url"
                target="_blank">
                {{ item.url }}
              </a>
              <a-avatar
                slot="avatar"
                shape="square"
                :size="48"
                :src="`/resources/images/platforms/${item.platform}.png`" />
            </a-list-item-meta>
            <!-- Status -->
            <a-tag
              class="mr-4 d-none d-lg-block text-uppercase"
              color="red"
              v-if="item.expired">
              {{ $t('expired') }}
            </a-tag>
            <a-tag
              class="mr-4 d-none d-lg-block text-uppercase"
              :color="item.activation === 'ACTIVE' ? 'green' : 'red'"
              v-else>
              {{ $t(`enum.activation.${item.activation}`) }}
            </a-tag>
            <!-- Actions -->
            <div slot="actions"
              v-show="$auth.granted(acl.shops.update)">
              <a-dropdown :trigger="['click']">
                <a-menu slot="overlay">
                  <!-- Configure -->
                  <a-menu-item
                    @click="() => onUpdate(item)">
                    <a-icon type="form"/>
                    {{ $t('msg.shop.action.update') }}
                  </a-menu-item>
                  <!-- Configure -->
                  <a-menu-item
                    @click="() => onConfigure(item)"
                    v-if="item.platform === 'MLI'">
                    <a-icon type="setting"/>
                    {{ $t('msg.shop.action.configure') }}
                  </a-menu-item>
                  <!-- Reconnect -->
                  <a-menu-item
                    @click="() => onReconnect(item)">
                    <a-icon type="sync"/>
                    {{ $t('msg.shop.action.reconnect') }}
                  </a-menu-item>
                  <!-- Disconnect -->
                  <a-menu-item
                    class="text-danger"
                    @click="() => onDisconnect(item)">
                    <a-icon type="delete"/>
                    {{ $t('msg.shop.action.disconnect') }}
                  </a-menu-item>
                </a-menu>
                <slot name="button">
                  <a-button icon="ellipsis"/>
                </slot>
              </a-dropdown>
            </div>
          </a-list-item>
        </a-list>
      </div>
    </div>
  </div>
</template>
<script>
import acl from '@/auth/acl'
import lms from '@/api/lms'
import { Modal } from 'ant-design-vue'
export default {
  name: 'PlatformConnected',
  data: function () {
    return {
      acl,
      pagination: {
        page: 1,
        size: 30,
      },
    }
  },
  computed: {
    results() {
      return this.$store.getters['platforms/CONNECTED']
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      return lms.account.fetchShops(this.account)
        .then(response => this.$store.commit('platforms/SET_CONNECTED', response.data))
    },
    onUpdate(item) {
      this.$router.push(`/shops/${item.id}/update`)
    },
    onConfigure(item) {
      this.$router.push(`/shops/${item.id}/configure?type=${item.platform}`)
    },
    onReconnect(item) {
      this.$router.push({
        path: '/shops/connect',
        query: {
          type: item.platform,
          account: this.account,
        },
      })
    },
    onDisconnect(item) {
      Modal.confirm({
        title: this.$t('msg.platform.action.delete'),
        content: this.$t('msg.platform.confirm.delete'),
        okText: this.$t('confirm'),
        cancelText: this.$t('cancel'),
        okType: 'danger',
        onOk: () => {
          lms.platform.uninstall(item.platform, item.id)
            .then(() => this.fetch())
        },
      })
    },
  },
}
</script>
